
import {Popup, DatetimePicker, Cell, CellGroup, Slider} from 'vant'
import {checkBrowser, getTime, transform} from '../../../assets/js/xjpublic';
import { errorModal } from '../../../assets/js/xjcommon';
// 方法一，加载顺序有问题
// import AMap from 'AMap' // 引入高德地图
// 方法二
import {AMap, jsSdk} from '../../../assets/libs/loadjs';

export default {
  name: 'home',
  components: {
    [Popup.name]: Popup,
    [DatetimePicker.name]: DatetimePicker,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Slider.name]: Slider,
  },
  data () {
    return {
      showTrack: false,
      startTime: '',
      endTime: '',
      startTimeDate: null,
      endTimeDate: null,
      showPopupStartTime: false,
      showPopupEndTime: false,
      minDate: new Date(2019, 0, 1),
      maxDate: new Date(),
      currentDate: new Date(),
      pointData: [],
      showTrackList: false,
      pathPointDataAll: [],
      pathPointDataShow: [],
      pathPointDataShowIndex: -1,
      showListInfo: false,
      onlyShowAddress: '',
      // 轨迹状态(start,pause,resume)
      actionState: '',
      myNavg: null,
      // 轨迹速度
      navgSpeed: 30,
      // before
      mapCenter: [104.065755, 30.657555],
      mapZoom: 16,
      mapIcon: require('../../../assets/images/map/ic_redcar.png'),
      mapAngle: 0,
    }
  },
  methods: {
    openTrackQueryFn () {
      if (this.pathPointDataAll && this.pathPointDataAll.length > 0) {
        this.showTrackList = true;
      } else {
        this.showTrack = true;
      }
    },
    onclosePopupFn () {
      this.showPopupStartTime = false;
      this.showPopupEndTime = false;
    },
    // 选择开始日期
    selectStartTimeFn () {
      this.currentDate =  this.startTime ? new Date(this.startTime) : new Date();
      this.showPopupStartTime = true;
    },
    onSelectStartTimeFn (value) {
      this.startTime = getTime.getFormatDate(4, value);
      this.startTimeDate = value;
      this.showPopupStartTime = false;
    },
    // 选择结束日期
    selectEndTimeFn () {
      this.currentDate =  this.endTime ? new Date(this.endTime) : new Date();
      this.showPopupEndTime = true;
    },
    onSelectEndTimeFn (value) {
      this.endTime = getTime.getFormatDate(4, value);
      this.endTimeDate = value;
      this.showPopupEndTime = false;
    },
    // 查询检查日期间隔
    queryCheckFn () {
      this.showListInfo = false;
      this.onlyShowAddress = '';
      let startTimeStamp = new Date(this.startTimeDate).valueOf();
      let endTimeStamp = new Date(this.endTimeDate).valueOf();
      if (!startTimeStamp) {
        this.$toast('请选择开始时间');
        return
      }
      if (!endTimeStamp) {
        this.$toast('请选择结束时间');
        return
      }
      if (startTimeStamp > endTimeStamp) {
        this.$dialog({
          message: '结束时间不能小于开始时间'
        });
        return
      }
      if (endTimeStamp - startTimeStamp > 60000 * 60 * 24 * 2) {
        this.$dialog({
          message: '查询的日期间隔不能超过48小时'
        });
        return
      }
      this.getPointInfoFn();
    },
    // 获取轨迹点(测试环境,832731909001178,2019-11-02有数据)
    getPointInfoFn () {
      let _this = this;
      this.$toast.loading({
        mask: true,
        duration: 0,
        message: '加载中...'
      });
      this.$axios.post('/travel/query', { startTime: this.startTimeDate, endTime: this.endTimeDate })
        .then(function (response) {
          // console.log(response);
          _this.$toast.clear();
          if (response.data.ret === 0) {
            if (response.data.data && response.data.data.length > 0) {
              let resData = response.data.data;
              let resDataAfter = [];
              for (let i = 0; i < resData.length; i++) {
                resDataAfter.push([resData[i].lon, resData[i].lat])
              }
              _this.pointData = resDataAfter;
              _this.pointSplitFn(resData);
            } else {
              _this.$dialog({
                message: '该时间段未查询出轨迹'
              });
            }
          } else {
            _this.$dialog({
              message: response.data.msg ? response.data.msg + '（' + response.data.ret + '）' : '获取位置信息失败（' + response.data.ret + '）'
            })
          }
        })
        .catch(function (error) {
          _this.$toast.clear();
          errorModal(error, 551);
        })
    },
    // 轨迹点分段
    pointSplitFn (beforePointData) {
      // beforePointData是分段前的数据
      // 初始化
      this.pathPointDataAll = [];
      let beforePointDataLength = beforePointData.length;
      let pathPointList = null;
      let pathPointListKong = {
        startPoint: [],
        startAdr: '',
        startTime: '',
        endPoint: [],
        endAdr: '',
        endTime: '',
        pathPointData: [],
        pathPointInfo: []
      };
      // 上一个点的时间戳
      let previousTime = beforePointData[0].time;
      // 新的时间段,设为空
      pathPointList = JSON.parse(JSON.stringify(pathPointListKong));
      // 新的时间段,开始点坐标
      pathPointList.startPoint = [beforePointData[0].lon, beforePointData[0].lat];
      // 新的时间段,开始时间
      pathPointList.startTime = this.timestampToTime(beforePointData[0].time);
      // 循环所有轨迹点
      for (let i = 0; i < beforePointData.length; i++) {
        // if (i > 0 && beforePointData[i].lon === beforePointData[i - 1].lon && beforePointData[i].lat === beforePointData[i - 1].lat) {
        //   beforePointData.splice(i, 1);
        //   beforePointDataLength--;
        //   continue;
        // }
        // 轨迹分段,时间间隔10分钟
        if (beforePointData[i].time - previousTime < 600000) {
          // 如果时间间隔小于10分钟,将该轨迹点push到该时间段的pathPointData
          // 火星坐标转百度坐标,调用公共js中的bd_encrypt方法
          let nowPoint = [beforePointData[i].lon, beforePointData[i].lat];
          let nowInfo = {
            speed: beforePointData[i].speed,
            direct: beforePointData[i].direct,
            time: this.timestampToTime(beforePointData[i].time)
          };
          // pathPointData代表一段里面的轨迹点坐标，为一个数组
          pathPointList.pathPointData.push(nowPoint);
          // pathPointInfo代表一段里面的轨迹点信息，为一个数组
          pathPointList.pathPointInfo.push(nowInfo);
          // 最后一个轨迹点
          if (i === beforePointDataLength - 1) {
            pathPointList.endPoint = [beforePointData[i].lon, beforePointData[i - 1].lat];
            pathPointList.endTime = this.timestampToTime(beforePointData[i].time);
            this.pathPointDataAll.push(pathPointList);
          }
        } else if (beforePointData[i].time - previousTime >= 600000) {
          // 如果时间间隔大于等于10分钟,设置上一个时间段的最后一个轨迹点
          pathPointList.endPoint = [beforePointData[i - 1].lon, beforePointData[i - 1].lat];
          pathPointList.endTime = this.timestampToTime(beforePointData[i - 1].time);
          this.pathPointDataAll.push(pathPointList);
          // 如果时间间隔大于等于10分钟,重新创建时间段
          previousTime = beforePointData[i].time;
          pathPointList = JSON.parse(JSON.stringify(pathPointListKong));
          pathPointList.startPoint = [beforePointData[i].lon, beforePointData[i].lat];
          pathPointList.startTime = this.timestampToTime(beforePointData[i].time);
          let nowPoint = [beforePointData[i].lon, beforePointData[i].lat];
          let nowInfo = {
            speed: beforePointData[i].speed,
            direct: beforePointData[i].direct,
            time: this.timestampToTime(beforePointData[i].time)
          };
          pathPointList.pathPointData.push(nowPoint);
          pathPointList.pathPointInfo.push(nowInfo);
        }
        previousTime = beforePointData[i].time;
        // 轨迹点分段end
      }
      let _this = this;
      for (let j = 0; j < this.pathPointDataAll.length; j++) {
        // this.pointToAddFn(this.pathPointDataAll[j].startPoint, 'start', j);
        // this.pointToAddFn(this.pathPointDataAll[j].endPoint, 'end', j);
        // 解析地址
        this.pointToAddressForTrack(this.pathPointDataAll[j].startPoint[0], this.pathPointDataAll[j].startPoint[1], 1, j, function (res) {
          _this.pathPointDataAll[res.index].startAdr = res.address;
        });
        this.pointToAddressForTrack(this.pathPointDataAll[j].endPoint[0], this.pathPointDataAll[j].endPoint[1], 1, j, function (res) {
          _this.pathPointDataAll[res.index].endAdr = res.address;
        });
      }
      // 搜索界面进入搜索结果界面
      if (_this.pathPointDataAll.length === 0) {
        this.mapCenter = [beforePointData[0].lon, beforePointData[0].lat];
        this.mapAngle = beforePointData[0].direct;
        this.showTrack = false;
        this.initMap('point');
        this.pointToAddressForTrack(beforePointData[0].lon, beforePointData[0].lat, 1, 0, function (res) {
          console.log(res.address);
          _this.onlyShowAddress = res.address;
          _this.showListInfo = true;
        });
        this.$dialog({
          message: '该时间段车辆位置未发生变化'
        });
      } else {
        this.showTrack = false;
        this.showTrackList = true;
      }
    },
    pointToAddressForTrack (lon, lat, type, index, callBack) {
      // 逆地理编码
      // 加载地理编码插件
      AMap.plugin(['AMap.Geocoder'], function () {
        let MGeocoder = new AMap.Geocoder({
          radius: 1000,
          extensions: 'all'
        });
        // 返回地理编码结果
        // 每次都解析数组的第一组坐标点
        MGeocoder.getAddress([lon, lat], function (status, result) {
          // result可能为空对象
          let showAddress = '';
          if (status === 'complete' && result.info === 'OK') {
            let addressInfo = result.regeocode.addressComponent;
            if (type === 1) {
              // 地图自动生成的详细地址
              showAddress = result.regeocode.formattedAddress;
            }
            callBack({code: 0, address: showAddress, index: index});
          } else {
            callBack({code: 1, address: showAddress, index: index, msg: '地址无法解析'});
          }
        })
      });
    },
    // 时间戳转时间格式
    timestampToTime (timestamp) {
      let date = new Date(timestamp);
      let Y = date.getFullYear() + '-';
      let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
      let D = (date.getDate() < 10 ? '0' + date.getDate() + ' ' : date.getDate()) + ' ';
      let h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
      let m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':';
      let s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
      return Y + M + D + h + m + s;
    },
    selectTrackList (index) {
      console.log(this.pathPointDataAll[index]);
      console.log(this.pathPointDataAll[index].pathPointData.length);
      this.pathPointDataShow = this.pathPointDataAll[index];
      this.showTrackList = false;
      this.showListInfo = true;
      this.pathPointDataShowIndex = index;
      if (this.pathPointDataShow.pathPointData.length === 1) {
        this.mapCenter = [this.pathPointDataShow.pathPointData[0][0], this.pathPointDataShow.pathPointData[0][1]];
        this.mapAngle = this.pathPointDataShow.pathPointInfo[0].direct || 0;
        this.initMap('point');
      } else {
        this.initMap('all');
      }
    },
    reQueryFn () {
      this.showTrackList = false;
      this.showListInfo = false;
      this.onlyShowAddress = '';
      this.pathPointDataAll = [];
      this.pathPointDataShowIndex = -1;
      this.showTrack = true;
    },
    // 初始化地图,showType参数为init只加载一个默认地图,不加载轨迹.showType参数为point只加载一个点
    initMap (showType) {
      let _this = this;
      let map = new AMap.Map('container', {
        center: this.mapCenter,
        resizeEnable: true,
        zoom: this.mapZoom
      });
      if (showType === 'init') {
        this.showTrack = true;
        return
      } else if (showType === 'point') {
        // 创建一个 Marker 实例：
        let marker = new AMap.Marker({
          position: new AMap.LngLat(this.mapCenter[0], this.mapCenter[1]),   // 经纬度对象，也可以是经纬度构成的一维数组[116.39, 39.9]
          title: '',
          offset: new AMap.Pixel(-17, -30),
          icon: this.mapIcon,
          angle: this.mapAngle
        });
        // 将创建的点标记添加到已有的地图实例：
        map.add(marker);
        return
      }

      // 轨迹
      AMapUI.load(['ui/misc/PathSimplifier', 'lib/$'], function (PathSimplifier, $) {
        if (!PathSimplifier.supportCanvas) {
          alert('当前环境不支持 Canvas！');
          return;
        }
        var defaultRenderOptions = {
          renderAllPointsIfNumberBelow: -1, //绘制路线节点，如不需要可设置为-1
          pathNavigatorStyle: {
            initRotateDegree: 0,
            width: 20,
            height: 20,
            autoRotate: true,
            lineJoin: 'round',
            content: 'defaultPathNavigator',
            fillStyle: '#087EC4',
            strokeStyle: '#116394', //'#eeeeee',
            lineWidth: 1,
            pathLinePassedStyle: {
              lineWidth: 4,
              strokeStyle: 'rgba(0, 122, 255, 1)',
              borderWidth: 1,
              borderStyle: '#eeeeee',
              dirArrowStyle: false
            }
          },
          pathLineStyle: {
            lineWidth: 4,
            strokeStyle: '#66AA00',
            borderWidth: 1,
            borderStyle: '#eeeeee',
            dirArrowStyle: false
          },
          startPointStyle: {
            radius: 4,
            fillStyle: '#007AFF',
            lineWidth: 6,
            strokeStyle: '#007AFF'
          },
          endPointStyle: {
            radius: 4,
            fillStyle: '#66AA00',
            lineWidth: 6,
            strokeStyle: '#66AA00'
          }
        };
        var pathSimplifierIns = new PathSimplifier({
          zIndex: 100,
          //autoSetFitView:false,
          map: map, //所属的地图实例
          getPath: function(pathData, pathIndex) {
            return pathData.path;
          },
          getHoverTitle: function(pathData, pathIndex, pointIndex) {
            if (pointIndex >= 0) {
              //point
              return pathData.name + '，点：' + pointIndex + '/' + pathData.path.length;
            }
            return pathData.name + '，点数量' + pathData.path.length;
          },
          // renderOptions: {
          //   renderAllPointsIfNumberBelow: 100 //绘制路线节点，如不需要可设置为-1
          // }
          renderOptions: defaultRenderOptions
        });

        window.pathSimplifierIns = pathSimplifierIns;

        // 设置数据
        pathSimplifierIns.setData([{
          name: '路线0',
          path: _this.pathPointDataShow.pathPointData
          // path: [
          //   [116.405289, 39.904987],
          //   [113.964458, 40.54664],
          //   [111.47836, 41.135964],
          // ]
        }]);

        // 对第一条线路（即索引0）创建一个巡航器

        // 方法一：默认
        // var navg1 = pathSimplifierIns.createPathNavigator(0, {
        //   loop: false, //循环播放
        //   speed: 5000 //巡航速度，单位千米/小时(原来为10000)
        // });
        // navg1.start();

        // 方法二：自定义
        function onload() {
          pathSimplifierIns.renderLater();
        }

        function onerror(e) {
          alert('图片加载失败！');
        }

        var navg2 = pathSimplifierIns.createPathNavigator(0, {
          loop: false,
          speed: _this.navgSpeed * 100 || 3000,
          pathNavigatorStyle: {
            width: 28,
            height: 50,
            content: PathSimplifier.Render.Canvas.getImageContent(_this.mapIcon, onload, onerror),
            strokeStyle: null,
            fillStyle: null
          },
          pathLineStyle: {
            lineWidth: 4,
            strokeStyle: '#66AA00',
            borderWidth: 1,
            borderStyle: '#eeeeee',
            dirArrowStyle: false
          },
        });

        navg2.start();

        // 控制
        _this.myNavg = navg2;
        _this.actionState = 'start';
      });
      // 轨迹
    },
    // 控制暂停
    pauseAndResumeFn (actionState) {
      this.actionState = actionState;
      this.myNavg[actionState]();
    },
    // 速度控制
    onChangeNavgSpeedFn (e) {
      this.myNavg.setSpeed(e * 100 || 3000);
    },
    // 高德地图定位(iso和网页浏览器可以,安卓不行)
    getLocationGaoFn () {
      let _this = this;
      let map = new AMap.Map('reserve-map', {
        zoom: _this.mapZoom,
        resizeEnable: true
      });
      AMap.plugin('AMap.Geolocation', function() {
        let geolocation = new AMap.Geolocation({
          enableHighAccuracy: true,//是否使用高精度定位，默认:true
          timeout: 10000,          //超过10秒后停止定位，默认：5s
          buttonPosition:'RB',    //定位按钮的停靠位置
          buttonOffset: new AMap.Pixel(10, 20),  //定位按钮与设置的停靠位置的偏移量，默认：Pixel(10, 20)
          zoomToAccuracy: true,   //定位成功后是否自动调整地图视野到定位点
        });
        map.addControl(geolocation);
        geolocation.getCurrentPosition(function(status,result){
          if(status === 'complete'){
            onComplete(result)
          }else{
            onError(result)
          }
        });
      });
      //解析定位结果
      function onComplete(data) {
        console.log('高德地图定位成功');
        _this.mapCenter = [data.position.lng, data.position.lat];
        _this.initMap('init');
        _this.$toast.clear();
      }
      //解析定位错误信息
      function onError(data) {
        console.log('高德地图定位失败');
        let cityCenter = map.getCenter();
        if (cityCenter && cityCenter.lng) {
          _this.mapCenter = [cityCenter.lng, cityCenter.lat];
        }
        _this.initMap('init');
        _this.$toast.clear();
      }
    },
    // 微信定位(安卓可以,iso不行)
    getLocationWxFn () {
      let _this = this;
      jsSdk(this.$store.state.customer, ['getLocation']).then(function(){
        wx.getLocation({
          type: 'gcj02', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
          success: function (res) {
            console.log('微信定位成功');
            let latitude = res.latitude; // 纬度，浮点数，范围为90 ~ -90
            let longitude = res.longitude; // 经度，浮点数，范围为180 ~ -180。
            _this.mapCenter = [longitude, latitude];
            _this.initMap('init');
            _this.$toast.clear();
          },
          fail:function(res){
            console.log('微信定位失败');
            _this.initMap('init');
            _this.$toast.clear();
            // _this.$notify({
            //   message: '微信定位失败',
            //   duration: 2500,
            //   background: '#ff3300'
            // })
          }
        });
      });
    },
  },
  mounted () {
    // console.error('AMapPos',AMap, Date.now());
    // 地图不能在 created 阶段调用，会找不到 html 元素 div#container
    document.getElementById('container').style.height = window.screen.height;
    // this.initMap('init');
    this.$toast.loading({
      mask: true,
      duration: 0,
      message: '加载中...'
    });
    // 判断是否是微信
    if (checkBrowser.isWx()) {
      // 判断是否是ios系统
      if (checkBrowser.isIOS()) {
        this.getLocationGaoFn();
      } else {
        this.getLocationWxFn();
      }
    } else {
      this.getLocationGaoFn();
    }
  },
  destroyed () {
    this.$notify.clear();
  }
}
